
import { CoatingArea } from "@rhinov/savane-js";
import { CoatingsComponentController } from "../CoatingsComponentController";
import { CoatingsComponentWidget } from "./CoatingsComponentWidget";
export class CoatingAreaComponentWidget extends CoatingsComponentWidget{

    areaController:CoatingsComponentController;
    areaEvents: Array<{id: string, event: string, handler: (event: Event) => void, param: string, set: {id: string, value: any}}>;
    coatingArea: CoatingArea;

    setCheckBox = (event: MouseEvent) => {
        this.areaController.getUpdateFGProperty((event.currentTarget as HTMLInputElement & { param?: string }).param!, this.coatingArea, (event.currentTarget as HTMLInputElement).checked);
    }

    override setPropertyComponentFG(event: Event) {
        super.setPropertyComponentFG(event);
        if ((event.currentTarget as HTMLInputElement & { param?: string }).param === "bevelValue") {
            let cleat = document.getElementById(`cleatCoating_${this.index}`);
            if (cleat) {
                switch (this.coatingArea.floorGeneratorSettings.bevelValue) {
                    case undefined:
                    case 0:
                        cleat.style.display = 'block';
                        break;
                    default:
                        cleat.style.display = 'none';
                        break;
                }
            }
        }
    }

    

    constructor (component: CoatingArea, index: number) {
        super(component, index);
        this.coatingArea = component as CoatingArea;
        this.areaController = new CoatingsComponentController(component);
        this.areaEvents = []
        if (this.coatingArea.floorGeneratorSettings) {
            this.areaEvents.push({id:"cleatButton-", event: "change", handler: (e: Event) => this.setCheckBox(e as MouseEvent), param: "cleat", set: {id: 'checked', value: this.coatingArea.floorGeneratorSettings.cleat}})
            this.areaEvents.push({id:"cutButton-", event: "change", handler: (e: Event) => this.setCheckBox(e as MouseEvent), param: "cut", set: {id: 'checked', value: this.coatingArea.floorGeneratorSettings.cut}})
        }
    }

    // init(endCallback: CallableFunction) {
    //    super.init(endCallback);
    // }

    override setCoatingsListener () {
        super.setCoatingsListener();
        this.areaEvents.forEach(({id, event, handler, param, set}) => {
            let element = document.getElementById(id + this.index) as HTMLInputElement & { param?: string };
            if (!element) return;
            if (param) {
                element.param = param;
            }
            if (set){
                if (set.value !== undefined) {
                    (element as any)[set.id] = set.value;
                } else {
                    (element as any)[set.id] = true;
                }
            }
            element.addEventListener(event, handler);
        })
    }

   

    override destroyCoatingsListener() {
        super.destroyCoatingsListener();
        this.areaEvents.forEach(({id, event, handler}) => {
            let element = document.getElementById(id + this.index);
            if (!element) return;
            
            element.removeEventListener(event, handler);
        })
    }

    // setListener() {
    //     super.setListener();
    // }

    // destroy() {
    //     super.destroy();
    //     return;
    // }

    endFloorgenerator(): string {
        var html = "";
        if (this.coatingArea.floorGeneratorSettings.pattern !== 'basket') {
            html += `
                <div class="togglebutton" style="padding-right:16px">
                    <label class="horizontal-toggle">
                        <div style="padding-right: 10px">Découpe</div>
                        <input id="cutButton-${this.index}" type="checkbox">
                        <span class="toggle"></span>
                    </label>
                </div>
            `;
        }
        if (this.coatingArea.floorGeneratorSettings.pattern === 'standard') {
            html += `
                <div id="cleatCoating_${this.index}" class="togglebutton" style="padding-right:16px">
                    <label class="horizontal-toggle">
                        <div style="padding-right: 10px">Tasseau</div>
                        <input id="cleatButton-${this.index}" type="checkbox">
                        <span class="toggle"></span>
                    </label>
                </div>
            `;
        }
        return html + `
            </div>
        `;
    }
    
    html(): string{
        return this.headerCoatings() + this.bodyCoatings();
    }
}